import { render, staticRenderFns } from "./DeliveryGoodsInfo.vue?vue&type=template&id=c326bb58&scoped=true&"
import script from "./DeliveryGoodsInfo.vue?vue&type=script&lang=js&"
export * from "./DeliveryGoodsInfo.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryGoodsInfo.vue?vue&type=style&index=0&id=c326bb58&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c326bb58",
  null
  
)

export default component.exports